
  var _styles = {
  "rr-container": {
    "display": "flex",
    "flexDirection": "column",
    "width": "10rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderTopLeftRadius": "0.42667rem",
    "borderTopRightRadius": "0.42667rem",
    "overflow": "hidden",
    "height": "100%"
  },
  "rr-header": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "10rem",
    "height": "1.33333rem",
    "position": "relative",
    "paddingTop": "0.42667rem",
    "paddingBottom": "0.21333rem"
  },
  "rr-title-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "rr-title": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.45333rem",
    "fontWeight": "600",
    "lineHeight": "0.58667rem",
    "color": "rgb(17,17,17)",
    "textAlign": "center"
  },
  "rr-close-btn": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "0.74667rem",
    "height": "0.74667rem",
    "position": "absolute",
    "right": "0.32rem",
    "top": "0.29333rem"
  },
  "rr-close-icon": {
    "width": "0.48rem",
    "height": "0.48rem",
    "backgroundColor": "rgb(153,153,153)",
    "borderRadius": "0.24rem"
  },
  "rr-tabs": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "9.09333rem",
    "height": "1.06667rem",
    "marginLeft": "0.45333rem",
    "marginRight": "0.45333rem",
    "marginTop": "0.24rem",
    "marginBottom": "0.29333rem",
    "backgroundColor": "rgb(231,231,231)",
    "borderRadius": "0.53333rem",
    "position": "relative",
    "paddingLeft": "0.05333rem",
    "paddingRight": "0.05333rem"
  },
  "rr-tabs-bg": {
    "position": "absolute",
    "width": "9.09333rem",
    "height": "1.06667rem",
    "backgroundColor": "rgb(231,231,231)",
    "borderRadius": "0.53333rem"
  },
  "rr-tab-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "flex": 1,
    "height": "0.96rem",
    "borderRadius": "0.48rem",
    "zIndex": 1
  },
  "rr-tab-item-active": {
    "backgroundColor": "rgb(255,255,255)"
  },
  "rr-tab-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "600",
    "lineHeight": "0.53333rem",
    "color": "rgb(17,17,17)",
    "textAlign": "center"
  },
  "rr-tab-text-active": {
    "color": "rgb(17,17,17)"
  },
  "rr-activity-time": {
    "paddingLeft": "0.42667rem",
    "paddingRight": "0.42667rem"
  },
  "rr-activity-time-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "400",
    "lineHeight": "0.45333rem",
    "color": "rgb(85,85,85)"
  },
  "rr-content": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1,
    "width": "10rem",
    "paddingLeft": "0.42667rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": "0.42667rem",
    "overflow": "hidden"
  },
  "rr-loading": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "1.33333rem",
    "width": "100%"
  },
  "rr-call-record-item": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.32rem",
    "paddingTop": "0.48rem",
    "paddingBottom": "0.48rem",
    "paddingLeft": "0.48rem",
    "paddingRight": "0.48rem",
    "marginBottom": "0.32rem",
    "height": "1.92rem",
    "width": "9.14667rem"
  },
  "rr-call-record-left": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "flex": 1
  },
  "rr-call-record-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.58667rem",
    "marginBottom": "0.08rem"
  },
  "rr-call-record-time": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem"
  },
  "rr-call-record-right": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "flex-end"
  },
  "rr-call-record-amount": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.56rem",
    "marginBottom": "0.05333rem"
  },
  "rr-call-record-desc": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem"
  },
  "rr-rebate-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "backgroundColor": "rgb(247,247,247)",
    "borderRadius": "0.32rem",
    "paddingTop": "0.37333rem",
    "paddingBottom": "0.37333rem",
    "paddingLeft": "0.32rem",
    "paddingRight": "0.32rem",
    "minHeight": "1.57333rem"
  },
  "rr-rebate-price": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.86667rem",
    "flexShrink": 0
  },
  "rr-rebate-amount-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "rr-rebate-symbol": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "fontWeight": "700",
    "lineHeight": "0.72rem",
    "color": "rgb(255,45,25)",
    "marginRight": "0.02667rem"
  },
  "rr-rebate-amount": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.72rem",
    "lineHeight": "0.82667rem",
    "fontWeight": "700",
    "color": "rgb(255,45,25)"
  },
  "rr-rebate-use-rule": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "fontWeight": "400",
    "lineHeight": "0.37333rem",
    "color": "rgb(255,45,25)",
    "marginTop": "0.05333rem",
    "textAlign": "center"
  },
  "rr-rebate-info": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "flex": 1,
    "marginLeft": "0.26667rem",
    "marginRight": "0.21333rem"
  },
  "rr-rebate-name": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "lineHeight": "0.53333rem",
    "color": "rgb(17,17,17)"
  },
  "rr-rebate-period": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "fontWeight": "400",
    "lineHeight": "0.42667rem",
    "color": "rgb(136,136,136)",
    "marginTop": "0.08rem"
  },
  "rr-rebate-action": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "flexShrink": 0
  },
  "rr-rebate-use-btn": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.6rem",
    "height": "0.74667rem",
    "backgroundColor": "rgb(255,207,0)",
    "borderRadius": "0.37333rem"
  },
  "rr-rebate-use-btn-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.34667rem",
    "fontWeight": "600",
    "lineHeight": "0.48rem",
    "color": "rgb(17,17,17)",
    "textAlign": "center"
  },
  "rr-rebate-used-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.34667rem",
    "fontWeight": "400",
    "lineHeight": "0.48rem",
    "color": "rgb(153,153,153)",
    "width": "1.6rem",
    "textAlign": "center"
  },
  "rr-hotel-reward-item": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(255,252,245)",
    "borderRadius": "0.48rem",
    "paddingTop": "0.58667rem",
    "paddingBottom": "0.48rem",
    "paddingLeft": "0.48rem",
    "paddingRight": "0.54667rem",
    "height": "1.92rem"
  },
  "rr-hotel-reward-left": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "flex": 1
  },
  "rr-hotel-reward-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.48rem",
    "maxWidth": "4.97333rem"
  },
  "rr-hotel-reward-tag-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.10667rem"
  },
  "rr-hotel-reward-tag": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.45333rem",
    "marginRight": "0.10667rem"
  },
  "rr-tag-free-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center"
  },
  "rr-tag-detail": {
    "backgroundColor": "rgb(255,241,240)",
    "borderTopRightRadius": "0.16rem",
    "borderBottomRightRadius": "0.16rem",
    "borderTopLeftRadius": 0,
    "borderBottomLeftRadius": 0,
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingLeft": "0.18667rem",
    "paddingRight": "0.10667rem",
    "height": "0.45333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "rr-tag-detail-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center"
  },
  "rr-hotel-reward-subtitle": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontSize": "0.26667rem",
    "lineHeight": "0.45333rem"
  },
  "rr-hotel-reward-right": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "2.34667rem",
    "height": "1.92rem"
  },
  "rr-hotel-reward-amount": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "marginTop": "0.42667rem"
  },
  "rr-amount-symbol": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.45333rem",
    "lineHeight": "0.66667rem",
    "marginRight": "0.02667rem"
  },
  "rr-amount-value": {
    "color": "rgb(17,17,17)",
    "fontSize": "0.61333rem",
    "lineHeight": "0.66667rem"
  },
  "rr-free-card-item": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(255,252,245)",
    "borderRadius": "0.32rem",
    "paddingLeft": "0.48rem",
    "paddingRight": "0.4rem",
    "width": "9.14667rem",
    "height": "2.12rem"
  },
  "rr-free-card-content": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "flex": 1
  },
  "rr-free-card-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.48rem"
  },
  "rr-free-card-subtitle": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginTop": "0.05333rem"
  },
  "rr-free-card-use-btn": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "2.2rem",
    "height": "0.8rem",
    "borderRadius": "0.4rem",
    "flexShrink": 0
  },
  "rr-free-card-use-btn-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "textAlign": "center"
  },
  "rr-reward-panel": {
    "display": "flex",
    "flexDirection": "column",
    "height": "100%"
  },
  "rr-assist-panel": {
    "display": "flex",
    "flexDirection": "column",
    "height": "100%"
  },
  "rr-coupon-tab-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "width": "100%",
    "height": "0.50667rem",
    "marginTop": "0.26667rem",
    "marginBottom": "0.21333rem",
    "marginLeft": "0.16rem",
    "paddingRight": "0.8rem"
  },
  "rr-coupon-tab-item": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "rr-coupon-tab-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "color": "rgb(46,31,0)"
  },
  "rr-coupon-tab-text-append": {
    "marginLeft": "0.10667rem"
  },
  "rr-coupon-tab-line": {
    "width": "0.53333rem",
    "height": "0.10667rem",
    "borderRadius": "0.26667rem"
  },
  "rr-coupon-scroll-view": {
    "flex": 1
  },
  "rr-coupon-list-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "rr-coupon-empty-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "paddingTop": "1.93333rem"
  },
  "rr-coupon-empty-text": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.48rem"
  },
  "coupon-usage-item-wrap": {
    "width": "9.14667rem",
    "height": "2.13333rem",
    "display": "flex",
    "flexDirection": "row",
    "marginBottom": "0.24rem",
    "paddingTop": "0.32rem",
    "paddingRight": 0,
    "paddingBottom": "0.32rem",
    "paddingLeft": 0
  },
  "coupon-usage-item-left": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "width": "2.48rem",
    "flexShrink": 0
  },
  "coupon-usage-item-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "center",
    "color": "rgb(255,45,25)"
  },
  "coupon-usage-amount-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "color": "rgb(255,45,25)"
  },
  "coupon-usage-item-price-symbol": {
    "color": "rgb(255,45,25)",
    "fontSize": "0.32rem",
    "fontWeight": "600",
    "fontFamily": "PingFang SC",
    "paddingTop": "0.4rem"
  },
  "coupon-usage-item-price-value": {
    "color": "rgb(255,45,25)",
    "fontSize": "0.69333rem",
    "fontWeight": "700"
  },
  "coupon-usage-item-condition": {
    "width": "100%",
    "height": "0.37333rem",
    "fontWeight": "400",
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem",
    "textAlign": "center",
    "marginTop": "-0.02667rem"
  },
  "coupon-usage-item-mid": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1,
    "alignItems": "flex-start",
    "marginLeft": "0.34667rem"
  },
  "coupon-usage-item-title": {
    "width": "100%",
    "height": "0.42667rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "marginBottom": "0.08rem"
  },
  "coupon-usage-item-limit": {
    "width": "100%",
    "height": "0.37333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem"
  },
  "coupon-usage-item-right": {
    "display": "flex",
    "flexDirection": "column",
    "width": "1.6rem",
    "alignItems": "center",
    "justifyContent": "center",
    "marginRight": "0.32rem",
    "flexShrink": 0
  },
  "coupon-usage-item-status-btn-inner": {
    "display": "flex",
    "flexDirection": "row",
    "width": "1.6rem",
    "height": "0.8rem",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "1.22667rem",
    "backgroundColor": "rgb(255,224,0)"
  },
  "coupon-usage-item-status-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  },
  "rr-no-more-text": {
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.57333rem"
  }
};



  module.exports = _styles;
  